import type { ResolverRuntime } from '../../definition/resolver';
import { makeFunctionalNext } from '../../definition/resolver';
import { toError, toLoading, toSuccess } from '../../definition/resolverState';
import { Metrics } from '../../../metrics/metrics';

export const attachPromise = <TData, TParams>(
  fetch: (params: TParams) => Promise<TData>,
  params: TParams,
  runtime: ResolverRuntime<TParams, TData>,
  transport: 'promise' | 'http' | 'chirp'
) => {
  const {
    env: { logger },
  } = runtime;
  const next = makeFunctionalNext(runtime);
  let pendingRefresh = false;

  const guardedFetch = async () => {
    if (pendingRefresh) {
      logger?.debug('refresh already pending');

      return;
    }

    pendingRefresh = true;

    Metrics.counter('resolver-refresh', { transport }).increment();

    logger?.debug('fetching');
    next(toLoading());

    try {
      const data = await fetch(params);

      logger?.debug('success');

      next(toSuccess(data));
    } catch (error) {
      logger?.debug('error');

      next(toError(error as Error));
    }

    pendingRefresh = false;
  };

  return {
    refresh: () => void guardedFetch(),
    detach: () => {},
  };
};
